import axios from 'axios'

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        const err = error.response.data;
        if ((err.name=="JsonWebTokenError") || (err.message=="jwt malformed")) { 
            const redirectPath = localStorage.getItem('redirectPath');
            window.localStorage.clear();
            if (redirectPath) localStorage.setItem('redirectPath',redirectPath);
            window.location.reload();
        } else if ((err.name=="TokenExpiredError") || (err.message=="jwt expired")) { 
            const redirectPath = localStorage.getItem('redirectPath');
            window.localStorage.clear();
            if (redirectPath) localStorage.setItem('redirectPath',redirectPath);
            window.location.reload();
        }
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
  list(obj = {}) {
      return new Promise(async (resolve, reject) => {
        try {
          const keys = ['page', 'limit', 'sortBy', 'sortDir', 'username','full_name','company'];
          let str = '';
          for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
              str += str ? '&' : '?';
              str += key + '=' + encodeURIComponent(obj[key]);
            }
          }
          const url = `/users/list${str}`;
          const { data } = await axios.get(url);
          const { meta, list } = data;
          obj.total = meta.total;
          resolve(list);
        } catch (error) {
          errorHandler(error, reject);
        }
      });
  },
  manage(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'username','full_name','company','isdeleted'];
        let str = '';
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
          }
        }
        const url = `/users/manage${str}`;
        const { data } = await axios.get(url);
        const { meta, list } = data;
        obj.total = meta.total;
        resolve(list);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
},  
  exportxls(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'username','full_name','company'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/users/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'userlist.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
},  
  usermodul(obj = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'modulname'];
        let str = '';
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
          }
        }
        const url = `/users/usermodul${str}`;
        const { data } = await axios.get(url);
        const { meta, list } = data;
        obj.total = meta.total;
        resolve(list);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  exportusermodul(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'modulname'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/users/exportusermodul${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'modul_list_user.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
},  

  modul() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/auth/modules/");
            resolve(data);
        } catch (error) {
            console.log(error);
            console.log('-- paksa login --, from Path: ', window.location.href);
            clearInterval(window.tokenRefreshInterval);
            window.localStorage.clear();
            window.location.reload();
            errorHandler(error, reject)
        }
    });
},

  insert (data) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.post('/users', data)
        resolve(resp)
      } catch (error) {
        errorHandler(error, reject)
      }
    })
  },
  update (data) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.put(`/users/${data.user_id}`, data)
        resolve(resp)
      } catch (error) {
        errorHandler(error, reject)
      }
    })
  },
  resetpwd (data) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.put(`/users/reset/${data.user_id}`, data)
        resolve(resp)
      } catch (error) {
        errorHandler(error, reject)
      }
    })
  },
  remove (obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.delete(`/users/${obj.user_id}`)
        resolve(resp)
      } catch (error) {
        errorHandler(error, reject)
      }
    })
  },
  detail (obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`/users/detail/${obj.user_id}`)
        resolve(data)
      } catch (error) {
        errorHandler(error, reject)
      }
    })
  },
  company(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        if (obj.holding) {
          const { data } = await axios.get(`/users/companies?holding=${encodeURIComponent(obj.holding)}`)
          resolve(data)
        } else {
          const { data } = await axios.get(`/users/companies`)
          resolve(data)
        }
      } catch (error) {
        errorHandler(error, reject)
      }
    })
  },
  

}
